import * as Yup from 'yup';
export const loginValidationSchema = Yup.object().shape({
    hash_tx: Yup.string()
        .min(6, 'Password Too Short!')
        .max(50, 'Password Too Long!')
        .required('Password required!'),
    username_tx: Yup.string().required('Username required!'),
});